import Link from "plos/src/components/links/Link/Link";
import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";

const PickTeamHelp = () => (
  <div className={copy}>
    <Trans ns="help" i18nKey="contextualHelp.pickTeam.description">
      <p>
        Your team scores points based on your chosen 11 players. It must be set
        out in a valid formation that includes at least three defenders, at
        least two midfielders and at least one forward.
      </p>
      <p>
        If a starting player does not play, the first eligible bench player will
        substitute in automatically.
      </p>
      <p>
        Your selected captain earns double points. A vice-captain will score
        double points if your chosen captain fails to play.
      </p>
      <p>Your final line-up must be chosen before the Gameweek deadline.</p>
      <Link
        href={`${
          import.meta.env.VITE_HF_BASE
        }/en/news/2174419/fpl-basics-how-to-pick-a-squad`}
      >
        FPL Basics Explained: How to pick a squad
      </Link>
    </Trans>
  </div>
);

export default PickTeamHelp;
